module.exports = function() {
  return new Worker(__webpack_public_path__ + "af7d58cf5c1a56351053.worker.js");
};